module.exports = __webpack_public_path__ + "img/car_0001.2031ea0b.jpg";